import styled from '@emotion/styled';
import type { IconButtonProps } from '@hotjar/hotsauce';
import { IconButton, tokens } from '@hotjar/hotsauce';
import { css } from '@emotion/react';

const roundButtonStyles = css`
  border-radius: 50%;
  border: 0;
  outline: none;
  padding: ${tokens.spacer.x0};
  background-color: ${tokens.color.ui_background};
  display: inline-flex;
  ${tokens.transition('background-color')};

  &:hover {
    background-color: ${tokens.color.bg_hover};
    border-radius: 50%;
    color: ${tokens.color.text_default};
  }

  &:focus {
    ${tokens.focus()};
    border-radius: 50%;
  }
`;

export const RoundButton = styled.button`
  ${roundButtonStyles}
`;

export const RoundIconButton = styled(IconButton)<Pick<IconButtonProps, 'as'>>`
  & a,
  & button {
    ${roundButtonStyles}
  }
`;
